import axios from 'axios';
import apiLmsManager from './apiLmsManager';

const apiLmsProgresso = axios.create({
  baseURL: process.env.REACT_APP_LMS_PROGRESSO_API_URL
});

apiLmsProgresso.interceptors.request.use(async config => {
  config.headers['Content-type'] = `application/json`;

  if (config.url !== '/login_check') {
    const token = localStorage.getItem('@RockfellerToken');
    token
      ? (config.headers['Authorization'] = `Bearer ${token}`)
      : (window.location.href = '/login');
  }

  return config;
});

apiLmsProgresso.interceptors.response.use(
  async response => {
    return response;
  },
  async error => {
    console.log(error);
    if (
      error.response.status === 401 &&
      localStorage.getItem('@RockfellerRefreshToken')
    ) {
      const refreshToken = await apiLmsManager.post('/token/refresh', {
        refresh_token: localStorage.getItem('@RockfellerRefreshToken')
      });
      if (refreshToken.status === 401 || refreshToken.status === 403) {
        localStorage.removeItem('@RockfellerToken');
        window.location.href = '/login';
      }

      localStorage.setItem('@RockfellerToken', refreshToken.data.token);
      localStorage.setItem(
        '@RockfellerRefreshToken',
        refreshToken.data.refresh_token
      );
      window.location.href = window.location.pathname;
      const requestConfig = error.config;
      return axios(requestConfig);
    } else if (error.response.status === 403) {
      window.dispatchEvent(new CustomEvent('api:forbidden'));
    } else if (error.response.status === 401) {
      localStorage.removeItem('@RockfellerToken');
      localStorage.removeItem('@RockfellerRefreshToken');
      localStorage.removeItem('LOGO');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiLmsProgresso;
